import React from 'react';
import { Link } from 'react-router-dom';
import { templatePath } from '../Templates/templateData';
import './TemplateCard.css';

export default function TemplateCard({ template, onEdit, priority = false }) {
  return (
    <>
      <article className="public-template-card">
        <div className="public-template-preview">
          {template.previewImage ? (
            <img
              src={template.previewImage}
              alt={template.name}
              loading={priority ? "eager" : "lazy"}
              decoding="async"
              fetchPriority={priority ? "high" : "auto"}
              sizes="(max-width: 900px) 100vw, (max-width: 1024px) 50vw, 25vw"
              width="900"
              height="600"
            />
          ) : (
            <div className="public-template-empty">No preview</div>
          )}
        </div>

        <div className="public-template-titlebar">
          <p>{template.name}</p>
        </div>

        <div className="public-template-overlay">
          <div className="public-template-actions">
            <button type="button" className="public-template-primary" onClick={() => onEdit(template)}>
              Start designing
            </button>
            <Link className="public-template-secondary" to={templatePath(template)}>
              Preview
            </Link>
          </div>
        </div>
      </article>
    </>
  );
}
